import { html, LitElement } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import { unsafeSVG } from 'lit-html/directives/unsafe-svg';
import Styles from './styles.scss';

export default class AabIcon extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    this.svg = '';
    this.size = 5;
  }

  static get properties() {
    return {
      svg: { type: String },
      size: { type: Number },
      color: { type: String },
      label: { type: String },
    };
  }

  static get scopedElements() {
    return {};
  }

  static get styles() {
    return [Styles];
  }

  updated() {
    const svgElement = this.shadowRoot.querySelector('svg');

    if (svgElement) {
      const calculatedSize = this.size * 8;
      svgElement.style.width = `${calculatedSize}px`;
      svgElement.style.height = `${calculatedSize}px`;
      svgElement.style.display = 'inherit';

      if (this.color) {
        const svgPathElement = svgElement.querySelector('path');
        svgPathElement.style.fill = this.color;
      }

      if (this.label) {
        const title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
        title.textContent = this.label;
        svgElement.prepend(title);
      }
    }
  }

  render() {
    return html`${unsafeSVG(this.svg)}`;
  }
}
